import { render, staticRenderFns } from "./team-goods-add.vue?vue&type=template&id=4aec64ab&scoped=true&"
import script from "./team-goods-add.vue?vue&type=script&lang=js&"
export * from "./team-goods-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec64ab",
  null
  
)

export default component.exports